import { StyleSheet } from 'react-native'
import { darkLightColor, successColor, whiteBackgroundColor } from './colors'
import { DOBRA } from './fonts'

export const inputStyle = StyleSheet.create({
  basicInput: {
    fontFamily: DOBRA,
    color: darkLightColor,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderRadius: 6,
    borderColor: '#707070',
    padding: 10,
    height: 50,
    paddingLeft: 15,
    zIndex: 1,
  },

  invalidInput: {
    borderColor: 'red',
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderRadius: 6,
    padding: 10,
    height: 50,
    paddingLeft: 15,
    zIndex: 1,
  },

  validInput: {
    backgroundColor: 'transparent',
    borderWidth: 1.1,
    borderRadius: 6,
    padding: 10,
    height: 50,
    paddingLeft: 15,
    zIndex: 1,
    borderColor: successColor,
  },

  labelFloating: {
    position: 'absolute',
    top: -9,
    left: 10,
    fontSize: 13,
    zIndex: 3,
    backgroundColor: whiteBackgroundColor,
    paddingHorizontal: 7,
    color: darkLightColor,
  },

  label: {
    position: 'absolute',
    top: 16,
    left: 10,
    fontSize: 14,
    color: darkLightColor,
  },

  labelError: {
    color: 'red',
  },

  icon: {
    position: 'absolute',
    right: 0,
    top: 0,
    padding: 17,
    zIndex: 99999,
  },
})
